import { createReducer } from 'redux-act';

import {
  SELLER_FETCH_DATA_INIT,
  SELLER_FETCH_DATA_SUCCESS,
  SELLER_FETCH_DATA_FAIL,
  SELLER_DELETE_INIT,
  SELLER_DELETE_SUCCESS,
  SELLER_DELETE_FAIL,
  SELLER_CLEAR_DATA,
  SELLER_CREATE_INIT,
  SELLER_CREATE_SUCCESS,
  SELLER_CREATE_FAIL,
  SELLER_MODIFY_INIT,
  SELLER_MODIFY_SUCCESS,
  SELLER_MODIFY_FAIL,
  SELLER_CLEAN_UP,
  SELLER_CLEAR_DATA_LOGOUT
} from '../../actions/sellers';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false
};

export const sellersReducer = createReducer(
  {
    [SELLER_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true
    }),
    [SELLER_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.sellers,
      loading: false,
      error: null
    }),
    [SELLER_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [SELLER_DELETE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [SELLER_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.filter(elem => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true
    }),
    [SELLER_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [SELLER_CLEAR_DATA]: state => ({
      ...initialState,
      data: state.data
    }),
    [SELLER_CREATE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [SELLER_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload),
      loading: false,
      error: null,
      success: true
    }),
    [SELLER_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [SELLER_MODIFY_INIT]: state => ({
      ...state,
      loading: true
    }),
    [SELLER_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.map(elem => {
        if (elem.id === payload.id) {
          return payload;
        }
        return elem;
      }),
      loading: false,
      error: null,
      success: true
    }),
    [SELLER_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [SELLER_CLEAN_UP]: state => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false
    }),
    [SELLER_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState
    })
  },
  initialState
);
